import widget_watchbox_vpmes1_buy from './stocks/widget_watchbox_vpmes1_buy.mp3';
import widget_watchbox_vpmes1_sell from './stocks/widget_watchbox_vpmes1_sell.mp3';
import widget_watchbox_vpmes1d_buy from './stocks/widget_watchbox_vpmes1d_buy.mp3';
import widget_watchbox_vpmes1d_sell from './stocks/widget_watchbox_vpmes1d_sell.mp3';
import widget_watchbox_vpmes5_buy from './stocks/widget_watchbox_vpmes5_buy.mp3';
import widget_watchbox_vpmes5_sell from './stocks/widget_watchbox_vpmes5_sell.mp3';
import widget_watchbox_vpmes5f_buy from './stocks/widget_watchbox_vpmes5f_buy.mp3';
import widget_watchbox_vpmes5f_sell from './stocks/widget_watchbox_vpmes5f_sell.mp3';
import widget_watchbox_vpmes60_buy from './stocks/widget_watchbox_vpmes60_buy.mp3';
import widget_watchbox_vpmes60_sell from './stocks/widget_watchbox_vpmes60_sell.mp3';
import widget_watchbox_vpmes60f_buy from './stocks/widget_watchbox_vpmes60f_buy.mp3';
import widget_watchbox_vpmes60f_sell from './stocks/widget_watchbox_vpmes60f_sell.mp3';
import widget_watchbox_vpmesc1_buy from './stocks/widget_watchbox_vpmesc1_buy.mp3';
import widget_watchbox_vpmesc1_sell from './stocks/widget_watchbox_vpmesc1_sell.mp3';
import widget_watchbox_vpmesc5_buy from './stocks/widget_watchbox_vpmesc5_buy.mp3';
import widget_watchbox_vpmesc5_sell from './stocks/widget_watchbox_vpmesc5_sell.mp3';
import widget_watchbox_vpmndx1_buy from './stocks/widget_watchbox_vpmndx1_buy.mp3';
import widget_watchbox_vpmndx1_sell from './stocks/widget_watchbox_vpmndx1_sell.mp3';
import widget_watchbox_vpmndx1d_buy from './stocks/widget_watchbox_vpmndx1d_buy.mp3';
import widget_watchbox_vpmndx1d_sell from './stocks/widget_watchbox_vpmndx1d_sell.mp3';
import widget_watchbox_vpmndx5_buy from './stocks/widget_watchbox_vpmndx5_buy.mp3';
import widget_watchbox_vpmndx5_sell from './stocks/widget_watchbox_vpmndx5_sell.mp3';
import widget_watchbox_vpmndx60_buy from './stocks/widget_watchbox_vpmndx60_buy.mp3';
import widget_watchbox_vpmndx60_sell from './stocks/widget_watchbox_vpmndx60_sell.mp3';
import widget_watchbox_vpmnq1_buy from './stocks/widget_watchbox_vpmnq1_buy.mp3';
import widget_watchbox_vpmnq1_sell from './stocks/widget_watchbox_vpmnq1_sell.mp3';
import widget_watchbox_vpmnq1d_buy from './stocks/widget_watchbox_vpmnq1d_buy.mp3';
import widget_watchbox_vpmnq1d_sell from './stocks/widget_watchbox_vpmnq1d_sell.mp3';
import widget_watchbox_vpmnq5_buy from './stocks/widget_watchbox_vpmnq5_buy.mp3';
import widget_watchbox_vpmnq5_sell from './stocks/widget_watchbox_vpmnq5_sell.mp3';
import widget_watchbox_vpmnq5f_buy from './stocks/widget_watchbox_vpmnq5f_buy.mp3';
import widget_watchbox_vpmnq5f_sell from './stocks/widget_watchbox_vpmnq5f_sell.mp3';
import widget_watchbox_vpmnq60_buy from './stocks/widget_watchbox_vpmnq60_buy.mp3';
import widget_watchbox_vpmnq60_sell from './stocks/widget_watchbox_vpmnq60_sell.mp3';
import widget_watchbox_vpmnq60f_buy from './stocks/widget_watchbox_vpmnq60f_buy.mp3';
import widget_watchbox_vpmnq60f_sell from './stocks/widget_watchbox_vpmnq60f_sell.mp3';
import widget_watchbox_vpmspx1_buy from './stocks/widget_watchbox_vpmspx1_buy.mp3';
import widget_watchbox_vpmspx1_sell from './stocks/widget_watchbox_vpmspx1_sell.mp3';
import widget_watchbox_vpmspx1d_buy from './stocks/widget_watchbox_vpmspx1d_buy.mp3';
import widget_watchbox_vpmspx1d_sell from './stocks/widget_watchbox_vpmspx1d_sell.mp3';
import widget_watchbox_vpmspx5_buy from './stocks/widget_watchbox_vpmspx5_buy.mp3';
import widget_watchbox_vpmspx5_sell from './stocks/widget_watchbox_vpmspx5_sell.mp3';
import widget_watchbox_vpmspx60_buy from './stocks/widget_watchbox_vpmspx60_buy.mp3';
import widget_watchbox_vpmspx60_sell from './stocks/widget_watchbox_vpmspx60_sell.mp3';

export interface IVoiceOption {
	buy: HTMLAudioElement,
	sell: HTMLAudioElement
}

export interface IVoiceOptions {
	[key: string]: IVoiceOption
}

export const voiceOptions: IVoiceOptions = {
	ES1: {
		buy: new Audio(widget_watchbox_vpmes1_buy),
		sell: new Audio(widget_watchbox_vpmes1_sell),
	},
	ES1D: {
		buy: new Audio(widget_watchbox_vpmes1d_buy),
		sell: new Audio(widget_watchbox_vpmes1d_sell),
	},
	ES5: {
		buy: new Audio(widget_watchbox_vpmes5_buy),
		sell: new Audio(widget_watchbox_vpmes5_sell),
	},
	ES5F: {
		buy: new Audio(widget_watchbox_vpmes5f_buy),
		sell: new Audio(widget_watchbox_vpmes5f_sell),
	},
	ES60: {
		buy: new Audio(widget_watchbox_vpmes60_buy),
		sell: new Audio(widget_watchbox_vpmes60_sell),
	},
	ES60F: {
		buy: new Audio(widget_watchbox_vpmes60f_buy),
		sell: new Audio(widget_watchbox_vpmes60f_sell),
	},
	ESC1: {
		buy: new Audio(widget_watchbox_vpmesc1_buy),
		sell: new Audio(widget_watchbox_vpmesc1_sell),
	},
	ESC5: {
		buy: new Audio(widget_watchbox_vpmesc5_buy),
		sell: new Audio(widget_watchbox_vpmesc5_sell),
	},
	NDX1: {
		buy: new Audio(widget_watchbox_vpmndx1_buy),
		sell: new Audio(widget_watchbox_vpmndx1_sell),
	},
	NDX1D: {
		buy: new Audio(widget_watchbox_vpmndx1d_buy),
		sell: new Audio(widget_watchbox_vpmndx1d_sell),
	},
	NDX5: {
		buy: new Audio(widget_watchbox_vpmndx5_buy),
		sell: new Audio(widget_watchbox_vpmndx5_sell),
	},
	NDX60: {
		buy: new Audio(widget_watchbox_vpmndx60_buy),
		sell: new Audio(widget_watchbox_vpmndx60_sell),
	},
	NQ1: {
		buy: new Audio(widget_watchbox_vpmnq1_buy),
		sell: new Audio(widget_watchbox_vpmnq1_sell),
	},
	NQ1D: {
		buy: new Audio(widget_watchbox_vpmnq1d_buy),
		sell: new Audio(widget_watchbox_vpmnq1d_sell),
	},
	NQ5: {
		buy: new Audio(widget_watchbox_vpmnq5_buy),
		sell: new Audio(widget_watchbox_vpmnq5_sell),
	},
	NQ5F: {
		buy: new Audio(widget_watchbox_vpmnq5f_buy),
		sell: new Audio(widget_watchbox_vpmnq5f_sell),
	},
	NQ60: {
		buy: new Audio(widget_watchbox_vpmnq60_buy),
		sell: new Audio(widget_watchbox_vpmnq60_sell),
	},
	NQ60F: {
		buy: new Audio(widget_watchbox_vpmnq60f_buy),
		sell: new Audio(widget_watchbox_vpmnq60f_sell),
	},
	SPX1: {
		buy: new Audio(widget_watchbox_vpmspx1_buy),
		sell: new Audio(widget_watchbox_vpmspx1_sell),
	},
	SPX1D: {
		buy: new Audio(widget_watchbox_vpmspx1d_buy),
		sell: new Audio(widget_watchbox_vpmspx1d_sell),
	},
	SPX5: {
		buy: new Audio(widget_watchbox_vpmspx5_buy),
		sell: new Audio(widget_watchbox_vpmspx5_sell),
	},
	SPX60: {
		buy: new Audio(widget_watchbox_vpmspx60_buy),
		sell: new Audio(widget_watchbox_vpmspx60_sell),
	},
};
